if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
(() => {
  const Gallery = customElements.get('media-gallery');

  if (!Gallery || Gallery.prototype.variantGroupsInstalled) return;

  Gallery.prototype.variantGroupsInstalled = true;

  const originalSetActiveMedia = Gallery.prototype.setActiveMedia;

  Gallery.prototype.prepareVariantGroups = function () {
    if (this.variantPhotoGroups) return true;

    const source = this.querySelector(
      '[data-variant-photo-groups]'
    );

    if (!source) return false;

    let data;

    try {
      data = JSON.parse(source.textContent);
    } catch (error) {
      console.warn('Fotogroepen konden niet worden gelezen.', error);
      return false;
    }

    const anchors = new Set(
      data.variantMedia
        .filter((id) => id !== null)
        .map(String)
    );

    const groups = new Map();
    let currentGroup = null;

    data.media.forEach((id) => {
      const mediaId = String(id);

      if (anchors.has(mediaId)) {
        currentGroup = mediaId;
      }

      groups.set(mediaId, currentGroup);
    });

    this.variantPhotoGroups = {
      groups,
      anchors,
      selectedMedia: data.selectedMedia
    };

    return true;
  };

  Gallery.prototype.filterVariantPhotos = function (fullMediaId) {
    if (!this.prepareVariantGroups()) return;

    const { groups, anchors } = this.variantPhotoGroups;
    const selectedId = String(fullMediaId).split('-').pop();

    // Zonder gekoppelde variantfoto blijven alle media zichtbaar.
    const hasGroup = anchors.has(selectedId);

    const isVisible = (fullId) => {
      const id = String(fullId).split('-').pop();
      const group = groups.get(id);

      // Media vóór de eerste variantfoto zijn gemeenschappelijk.
      return !hasGroup || group == null || group === selectedId;
    };

    this.elements.viewer
      .querySelectorAll('[data-media-id]')
      .forEach((slide) => {
        const visible = isVisible(slide.dataset.mediaId);

        slide.classList.remove('product__media-item--variant');
        slide.hidden = !visible;

        if (visible) {
          slide.style.removeProperty('display');
        } else {
          slide.style.setProperty('display', 'none', 'important');
        }
      });

    if (this.elements.thumbnails) {
      this.elements.thumbnails
        .querySelectorAll('[data-target]')
        .forEach((thumbnail) => {
          const visible = isVisible(thumbnail.dataset.target);

          thumbnail.classList.remove('thumbnail-list_item--variant');
          thumbnail.hidden = !visible;

          if (visible) {
            thumbnail.style.removeProperty('display');
          } else {
            thumbnail.style.setProperty(
              'display',
              'none',
              'important'
            );
          }
        });
    }

    // Laat de bestaande sliders hun zichtbare items opnieuw tellen.
    [this.elements.viewer, this.elements.thumbnails].forEach(
      (slider) => {
        if (!slider) return;

        if (typeof slider.initPages === 'function') {
          slider.initPages();
        } else if (typeof slider.resetPages === 'function') {
          slider.resetPages();
        }
      }
    );
  };

  Gallery.prototype.setActiveMedia = function (mediaId, prepend) {
    if (!this.elements.viewer.querySelector(
      `[data-media-id="${mediaId}"]`
    )) return;

    // Het thema gebruikt prepend=true bij een variantwisseling.
    // Een klik op een kleine foto wisselt niet van fotogroep.
    if (prepend) {
      this.filterVariantPhotos(mediaId);
    }

    // Bewaar de oorspronkelijke volgorde van de foto's.
    return originalSetActiveMedia.call(this, mediaId, false);
  };

  const initialize = () => {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      if (!gallery.prepareVariantGroups()) return;

      const selectedId =
        gallery.variantPhotoGroups.selectedMedia;

      if (!selectedId) return;

      const activeSlide = Array.from(
        gallery.elements.viewer.querySelectorAll('[data-media-id]')
      ).find(
        (slide) =>
          slide.dataset.mediaId.split('-').pop() === String(selectedId)
      );

      if (activeSlide) {
        gallery.setActiveMedia(activeSlide.dataset.mediaId, true);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {
      once: true
    });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
